<template>
  <svg
    version="1.1"
    id="svg6743"
    width="451.70532"
    height="451.70532"
    viewBox="0 0 451.70531 451.70532"
    sodipodi:docname="plin.icon.svg"
    inkscape:version="1.2.2 (b0a8486541, 2022-12-01)"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg">
    <defs
      id="defs6747">
      <clipPath
        clipPathUnits="userSpaceOnUse"
        id="clipPath6789">
        <path
          d="M 0,0 H 841.89 V 595.276 H 0 Z"
          id="path6787" />
      </clipPath>
    </defs>
    <sodipodi:namedview
      id="namedview6745"
      pagecolor="#ffffff"
      bordercolor="#666666"
      borderopacity="1.0"
      inkscape:showpageshadow="2"
      inkscape:pageopacity="0.0"
      inkscape:pagecheckerboard="0"
      inkscape:deskcolor="#d1d1d1"
      showgrid="false"
      inkscape:zoom="1.2837187"
      inkscape:cx="185.00938"
      inkscape:cy="294.06754"
      inkscape:window-width="3440"
      inkscape:window-height="1382"
      inkscape:window-x="0"
      inkscape:window-y="30"
      inkscape:window-maximized="1"
      inkscape:current-layer="g6751" />
    <g
      id="g6751"
      inkscape:groupmode="layer"
      inkscape:label="Page 1"
      transform="matrix(1.3333333,0,0,-1.3333333,-323.40666,689.46798)">
      <g
        id="g6753"
        style="fill:currentColor;fill-opacity:1"
        clip-path="none">
        <g
          id="g6755"
          style="fill:currentColor;fill-opacity:1">
          <g
            id="g6761"
            style="fill:currentColor;fill-opacity:1">
            <g
              id="g6763"
              style="fill:currentColor;fill-opacity:1">
              <path
                id="path6781"
                style="fill:currentColor;fill-opacity:1;stroke:none"
                d="M 411.94368 517.101 C 318.39386 517.101 242.555 441.26221 242.555 347.70939 C 242.555 328.04443 245.94425 309.17857 252.10725 291.61759 C 255.96923 269.53065 256.49254 259.71579 253.63654 244.60783 C 251.59056 233.79485 245.34343 226.72542 246.39143 216.58244 C 247.34143 207.37844 248.01731 202.11497 256.25129 193.20499 C 265.97227 183.35101 274.97434 183.95559 277.85334 183.51359 C 287.85632 181.97559 295.27244 187.65268 306.1424 189.00968 C 323.24238 191.14668 335.65437 192.31672 363.64631 185.31974 C 363.75731 185.29174 363.85765 185.28222 363.96565 185.25822 C 379.18461 180.77022 395.2737 178.32218 411.94368 178.32218 C 505.49548 178.32218 581.33382 254.15959 581.33382 347.70939 C 581.33382 441.26221 505.49548 517.101 411.94368 517.101 z M 396.4427 423.68791 C 402.78469 423.68791 407.94465 418.58114 407.94465 412.30314 L 407.94465 310.48625 C 407.94465 304.20925 402.78469 299.10295 396.4427 299.10295 C 390.52571 299.10295 385.61903 303.51465 385.03303 309.36564 L 385.01252 309.57804 L 385.01252 413.21281 L 385.03303 413.42521 C 385.61903 419.27521 390.52471 423.68791 396.4427 423.68791 z M 435.45588 413.92033 C 441.78688 413.92033 446.91975 408.78746 446.91975 402.45646 C 446.91975 396.12548 441.78688 390.99406 435.45588 390.99406 C 429.1249 390.99406 423.99202 396.12548 423.99202 402.45646 C 423.99202 408.78746 429.1249 413.92033 435.45588 413.92033 z M 337.65559 388.54924 C 359.54557 388.54924 375.43245 369.84516 375.43245 344.07219 C 375.43245 311.93922 354.57942 297.30412 335.20344 297.30412 C 329.80245 297.30412 324.70369 298.38084 320.21369 300.41984 C 317.6727 301.57384 314.8011 299.598 314.8011 296.809 L 314.8011 278.12638 C 314.8011 271.50439 309.11643 266.18442 302.37043 266.79142 C 296.39944 267.32542 292.03156 272.73097 292.03156 278.72697 L 292.03156 356.65519 C 292.03156 366.52918 291.38264 382.29142 291.38264 382.29142 C 291.04664 387.17442 298.38606 386.75187 298.38606 386.75187 L 309.16877 386.75187 C 312.25677 386.76887 312.11302 385.82279 312.72102 385.0468 C 313.32502 384.2748 314.23106 381.40299 320.51106 384.78898 C 325.56405 387.26898 331.3396 388.54924 337.65559 388.54924 z M 505.47542 388.54924 C 520.3394 388.54924 537.69612 378.61229 537.69612 350.60832 L 537.69612 311.10588 C 537.69612 305.04288 533.23479 299.58917 527.1888 299.13517 C 522.0538 298.74917 515.10392 300.45826 514.76692 310.48625 L 514.76692 348.97502 C 514.76692 361.645 510.04664 368.06779 500.73665 368.06779 C 492.70966 368.06779 487.31889 362.20166 485.53889 356.38566 L 485.46858 356.17326 C 485.01558 354.93126 484.74495 352.97298 484.74495 350.93498 L 484.74495 311.10588 C 484.74495 305.04288 480.28215 299.58917 474.23616 299.13517 C 469.10316 298.74917 464.11565 301.79484 462.31965 306.21183 C 462.31965 306.21183 461.91575 306.39725 461.81575 310.48625 L 461.81575 361.0673 C 461.81575 369.83929 461.62268 376.14613 461.17268 382.15812 C 460.98568 384.63812 462.94738 386.75187 465.43538 386.75187 L 478.26887 386.75187 C 479.72187 386.75187 480.54306 385.48294 481.76106 384.87394 C 482.95806 384.27394 487.72588 383.99048 489.72688 384.97648 C 494.49388 387.32848 499.83842 388.54924 505.47542 388.54924 z M 435.12483 386.75187 C 441.40082 386.75187 446.50813 381.64557 446.50813 375.36857 L 446.50813 310.48625 C 446.50813 304.20925 441.40082 299.10295 435.12483 299.10295 C 430.35883 299.10295 423.57747 301.11526 423.57747 310.48625 L 423.57747 377.3549 C 423.57747 383.88489 430.35883 386.75187 435.12483 386.75187 z M 333.24202 368.55998 C 325.09702 368.55998 317.86084 362.55401 315.64485 353.95402 C 315.27385 352.58902 314.8011 350.67661 314.8011 349.13761 L 314.8011 335.5717 C 314.8011 333.8747 315.05834 332.26331 315.35334 330.62931 C 315.35434 330.62431 315.35527 330.62113 315.35627 330.61613 C 317.54627 322.54214 324.51777 317.13078 332.75276 317.13078 C 345.11874 317.13078 352.50178 326.95742 352.50178 343.4174 C 352.50178 355.93239 346.546 368.55998 333.24202 368.55998 z " />
            </g>
          </g>
        </g>
      </g>
      <g
        id="g6783"
        clip-path="none">
        <g
          id="g6785"
          clip-path="url(#clipPath6789)">
          <g
            id="g6791"
            transform="translate(446.9199,402.457)"
            style="fill:#ffffff;fill-opacity:1" />
          <g
            id="g6795"
            transform="translate(396.4424,423.6875)" />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'plinIcon'
}
</script>
